<template>
  <div class="trendsreport-banner" v-if="loaded">
    <div class="trendsreport-banner__container">
      <article class="trendsreport-banner__card">
        <div class="trendsreport-banner__card-content">
          <h3
            class="trendsreport-banner__card-title"
            v-html="article.PageTitle"
          />
          <p class="trendsreport-banner__card-description">
            Read the latest Trends Report Executive Summary
          </p>
          <div class="trendsreport-banner__card-button">
            <BaseButton>
              <a :href="article.Link" class="trendsreport-banner__link">
                READ MORE
              </a>
            </BaseButton>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  import BaseButton from '~/components/base/BaseButton.vue';

  export default {
    name: 'TrendsReportBanner',
    components: {
      BaseButton,
    },
    data: () => ({
      loaded: false,
      article: null,
    }),
    props: {},
    methods: {},
    async mounted() {
      const response = await axios.get(
        '/trendsreport/tr-executive-summary-banner'
      );
      if (response.status === 200) {
        this.article = response.data;
        this.loaded = true;
      }
    },
  };
</script>
<style lang="scss" scoped>
  .trendsreport-banner {
    // flex: 1 auto;
    position: relative;
    width: 100%;
    height: 159px;
    z-index: 0;
    margin: 20px 0;
    @include screen-md {
      height: 204px;
    }
    @include screen-lg {
      height: 178px;
    }
    @include screen-xl {
      width: 70%;
    }
    &::before {
      content: '';
      position: absolute;
      top: -10px;
      left: -10px;
      width: 100%;
      height: 100%;
      background-color: var(--itr-green);
      border-radius: 10px;
      z-index: -1;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -10px;
      right: -10px;
      width: 100%;
      height: 100%;
      background-color: var(--itr-blue);
      border-radius: 10px;
      z-index: -1;
    }

    &__container {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding-left: 10px;
      padding-right: 10px;

      border: 4px solid var(--itr-white);
      border-radius: 10px;
      background: linear-gradient(95deg, #d9d9d9 12.68%, #f0f1f1 85.02%);
    }

    &__card {
      padding: 10px;
      max-height: 192px;
      height: 100%;
      width: 100%;
      overflow: hidden;
      @include screen-xl {
        padding: 20px 30px;
      }
    }

    &__card-content {
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      @include screen-sm {
        align-items: center;
        justify-content: space-between;
      }
      @include screen-md {
      }
    }

    &__card-title {
      font-size: 18px;
      font-weight: 900;
      margin: 8px 0;
      color: var(--itr-blue);
      @include screen-sm {
        width: 70%;
      }
      @media (min-width: 768px) {
        order: 1;
        width: 100%;
        font-size: 24px;
        line-height: 35px;
      }
      @media (min-width: 1450px) {
        width: 80%;
      }
    }

    &__card-description {
      font-size: 14px;
      font-weight: 700;
      color: var(--itr-gray);
      display: none;
      max-height: 130px;

      @media (min-width: 768px) {
        display: inline;
        order: 2;
        width: 70%;
      }
      @media (min-width: 1450px) {
        order: 3;
        // font-size: 18px;
      }
    }

    &__card-button {
      margin-left: auto;
      @media (min-width: 768px) {
        order: 3;
        margin: unset;
      }
      @media (min-width: 1450px) {
        order: 2;
        margin-top: 2rem;
      }
    }
    &__link {
      color: var(--itr-white) !important;
      &:hover {
        text-decoration: none !important;
      }
    }
  }
</style>
